import { render, staticRenderFns } from "./PaymentProviderReturn.vue?vue&type=template&id=36d3bd38"
import script from "./PaymentProviderReturn.vue?vue&type=script&lang=js"
export * from "./PaymentProviderReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports